import React from 'react';
import { useTranslation } from 'react-i18next';
import ColumnChart from "../../charts/ColumnChart";
import {Loader} from "../../loader/Loader";
import BlockTabs from "../../BlockTabs";

export default function ConsentByPurpose ({data = [], isSuccess, isFetching: isLoading, refetch}) {

  const { t } = useTranslation();

  const loaderProps = { success: (!isLoading && isSuccess), error: (!isLoading && !isSuccess), retry: refetch }

  return (

    <BlockTabs title={t("dataByDay.title")} defaultActiveKey="v2">
      <Loader {...loaderProps} key="v2" title="TCF V2">
        <ColumnChart data={data[2]}/>
      </Loader>
      <Loader {...loaderProps} key="v1" title="TCF V1" >
        <ColumnChart data={data[1]}/>
      </Loader>
    </BlockTabs>
  )
}
